import styled from 'styled-components';
import * as Colors from '../../styles/colors';

export const ModalContainer = styled.div`
  background-color: ${Colors.NEUTRAL_50};
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  padding-bottom: 18px;
  display: flex;
  flex-direction: column;
`;

export const ModalBody = styled.div`
  padding: 20px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
